import React from 'react';
import { motion } from 'framer-motion';
import Pinned from '../../../components/utils/pinned';
import Shape from '../../../components/utils/shape';
import { default as __ } from '../../../utils';
import { colors } from '../../../styles';
import './stat.css';

const Stat = ({ children = false, legend, value, shape, shade = false }) => {
  return (
    <motion.div
      whileTap={{ scale: 1.1 }}
      whileHover={{ scale: 1.1 }}
      className="stat-container col-center align-center"
      animate={false}
    >
      <Pinned tag="div">
        {shape ? (
          <Shape.Base
            vertices={shape.vertex}
            fill={'var(--black)'}
            size={shape.scaling}
            transform={shape.transforms ? shape.transforms : ''}
          >
            <p
              stat-display="value"
              style={{ color: `${shade ? shade : 'var(--purple)'}` }}
            >
              {__.zeroPad(value, 2)}
            </p>
          </Shape.Base>
        ) : (
          <p
            stat-display="value"
            style={{ color: `${shade ? shade : 'var(--purple)'}` }}
          >
            {__.zeroPad(value, 2)}
          </p>
        )}
      </Pinned>

      {children && children}
      {legend && (
        <Pinned tag="div" isCenteredX offsetY="120px">
          <p
            stat-display="label"
            style={{ color: `${shade ? shade : 'var(--purple)'}` }}
          >
            {legend}
          </p>
        </Pinned>
      )}
    </motion.div>
  );
};

export default Stat;
